import React from 'react'
import classNames from 'classnames'
import moment from 'moment'
import _ from 'lodash'
import immutable from 'immutable'


import {ChatItem} from './chatitem.component'

export class ChatList extends React.Component {
    constructor(props) {
        super(props)
        this._unseenChats = 0

        this._isMounted = false
        this._mountedAt = null
    }

    componentDidMount() {
        this._isMounted = true
        this._mountedAt = moment() // To compare against new chats. Diff will be negative for chats received after mounting
    }

    // TODO: this will break if a luna agent or bot sent the message
    // need to get the user's first and last name from elsewhere once
    // non-traveler users are sending chats
    findMsgUser(msg) {
        let msgUser = this.props.travelers.find((user) => {
            let public_id = user.get('public_id')
            if (public_id) {
                public_id = public_id.replace(/-/g, '')
            }
            return msg.get('sender_guid') === user.get('guid') || msg.get('sender_guid') === public_id
        })

        if (typeof msgUser == 'undefined') {
            msgUser = immutable.fromJS({
                'guid': msg.get('sender_guid'),
                'firstname': 'LUNA',
                'lastname': 'PLANNER'
            })
        }

        // do we need to check for how many we got? or does find() take care of that?
        return msgUser
    }

    // TODO: we could check for message id here instead of temp guid
    setMsgKey(msg) {
        if (msg.get('temporary_id') === null) {
            return msg.get('message_id')
        } else {
            return msg.get('temporary_id')
        }
    }

    isActiveUser(msgUser) {
        if (msgUser.get('guid') == this.props.currentUser.guid) {
            return true
        } else {
            return false
        }
    }

    calcMsgDelta(newMsgMap, oldMsg) {
        let newMsg = newMsgMap.toObject()
        let msgDelta = {showHash: false, showTime: false, showUser: false}

        // if we're changing topics, show a hashtag
        if (typeof oldMsg.hashtag == 'undefined' || newMsg.hashtag.get('title') != oldMsg.hashtag.get('title')) {
            msgDelta.showHash = true
        }

        // for now, let's just not show the hash
        msgDelta.showHash = false
    
        // if the time delta is greater than 3 minutes, show timestamp
        let timeDelta = moment(newMsg.created_at).diff(moment(oldMsg.created_at), 'seconds')
        if ( (typeof oldMsg.created_at == 'undefined') || timeDelta > 180) {
            msgDelta.showTime = true
        }
        // if the sended doesn't match, show the sender
        // also want to check against topic and time I think
        if (newMsg.sender_guid != oldMsg.sender_guid) {
            msgDelta.showUser = true
        }

        return msgDelta
    }

    render() {
        let lastMsg = {}
        let msgDelta = {}

        // this._unseenChats = 0 //reset each time as we serve all the chats at re-render
        // TODO: can we move this out of render and just append new chats?

        let chatItems = this.props.chat.map((message) => {
            let user = this.findMsgUser(message)
            let childKey = this.setMsgKey(message)
            let isMe = this.isActiveUser(user)

            // This chat happened after the component mounted and is not from me
            // if(moment(this._mountedAt).diff(moment.utc(message.get('created_at')), 'seconds') < 0 && !isMe){
            //   this._unseenChats++
            // }
      
            msgDelta = this.calcMsgDelta(message, lastMsg)
            lastMsg = message.toObject()
            // this is a function – how to reference in a function above
            let activateLeg = () => {
                let location = message.get('hashtag').slice(1)
                let leg = this.props.legs.find((leg) => {
                    return leg.getIn(['destination', 'title']) === location
                })

                if (leg) { this.props.onActivateLegByHashtag(leg.get('id')) }
            }



            return (
                <ChatItem key={childKey}
                          {...this.props}
                          message={message}
                          msgDelta={msgDelta}
                          user={user}
                          isMe={isMe}
                          childKey={childKey}/>
            )
        }, this)

        return (
            <div id="chat-item-list">{chatItems}</div>
        )
    }
}